// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picture-element[data-v-1de219ab]{display:inline-block}.picture-element .provider-icon[data-v-1de219ab]{width:50px;height:50px;min-width:50px;border-radius:20%;aspect-ratio:1}.picture-element .provider-icon.small[data-v-1de219ab]{width:24px;height:24px;min-width:24px;border-radius:4px}", ""]);
// Exports
module.exports = exports;
